export const getStoredTenantSlug = () => {
  const slug = localStorage.getItem("tenant_slug");
  return slug ? String(slug).trim().toLowerCase() : "";
};

const RESERVED_ROOT_SEGMENTS = new Set([
  "admin",
  "home-public",
  "about",
  "contact",
  "register",
  "alumni-register",
  "member-register",
  "guest-register",
  "company-register",
  "login",
  "forgot-password",
  "reset-password",
  "dashboard",
  "profile",
  "contact-dashboard",
  "organization",
  "mentorship",
  "mentors-guidance",
  "mentees-guidance",
  "careers",
  "employer-guidance",
  "applicants-guidance",
  "news",
  "donate",
  "events",
  "alumnione",
]);

export const getRouteTenantSlug = () => {
  const path = window.location.pathname || "";
  const segments = path.split("/").filter(Boolean);
  if (!segments.length) return "";

  const first = String(segments[0]).trim().toLowerCase();
  if (!first || RESERVED_ROOT_SEGMENTS.has(first)) return "";

  return first;
};

export const getActiveTenantSlug = () => {
  return getRouteTenantSlug() || getStoredTenantSlug();
};

export const getTenantHomePath = (tenantSlug = getStoredTenantSlug()) => {
  return tenantSlug ? `/${tenantSlug}/home` : "/home-public";
};

export const getTenantLoginPath = (tenantSlug = getStoredTenantSlug()) => {
  return tenantSlug ? `/${tenantSlug}/login` : "/login";
};

export const getTenantScopedPath = (path, tenantSlug = getStoredTenantSlug()) => {
  if (!path || typeof path !== "string") return path;

  const trimmed = path.trim();
  if (!trimmed) return trimmed;

  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith("#")) {
    return trimmed;
  }

  const normalized = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;

  if (!tenantSlug) {
    return normalized;
  }

  if (normalized === `/${tenantSlug}` || normalized.startsWith(`/${tenantSlug}/`)) {
    return normalized;
  }

  if (normalized === "/") {
    return getTenantHomePath(tenantSlug);
  }

  if (normalized === "/home-public") {
    return getTenantHomePath(tenantSlug);
  }

  return `/${tenantSlug}${normalized}`;
};
